import { ReactElement, ReactNode, useState } from "react";
import { useLocalStorage, useMediaQuery } from "usehooks-ts";
import { SignupContext, SignUpFlowStepType } from "../contexts/SignupContext";
import { TwoCompanySearchResponseType } from "@sellar-io/api-v2/types";
import { SignupFlowStep } from "./useSignupContext.shared";

export function SignupContextProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const [creditLimitQuoteValue, setCreditLimitQuoteValue] = useState<number>(0);
  const [company, setCompany] = useState<
    TwoCompanySearchResponseType[number] | null
  >(null);
  const [signupDialogActive, setSignupDialogActive] = useState<boolean>(false);
  const [buyerSignUpBusinessId, setBuyerSignUpBusinessId] = useState<
    number | undefined
  >(undefined);
  const [showLoginTitle, setShowLoginTitle] = useState<boolean>(false);
  const [basketTotal, setBasketTotal] = useState<number>();
  const [buyerSelectBusinessId, setBuyerSelectBusinessId] = useState<number>();
  const [step, setStep] = useState<SignUpFlowStepType>(
    SignupFlowStep.EmailStep,
  );
  const [redirectToMarket, setRedirectToMarket] = useState(false);
  const [
    redirectToSellarCreditOnboarding,
    setRedirectToSellarCreditOnboarding,
  ] = useState(false);
  const [hasAcceptedTermsAndConditions, setHasAcceptedTermsAndConditions] =
    useState<boolean>(false);
  const [, setUnAuthorisedUserPostcode] = useLocalStorage<string | undefined>(
    "unauthorisedUserPostcode",
    undefined,
  );
  const [, setUnAuthorisedUserLocation] = useLocalStorage<
    { lat: number; lng: number } | undefined
  >("unAuthorisedUserLocation", undefined);
  const isMobile = useMediaQuery("(max-width: 769px)");
  const endOnboarding = () => {
    setUnAuthorisedUserPostcode(undefined);
    setBuyerSelectBusinessId(undefined);
    setUnAuthorisedUserLocation(undefined);
    setSignupDialogActive(false);

    // reset();
    if (isMobile && signupDialogActive) {
      // Short term solution until we refactor App.tsx initialisation
      // Bug with Dialog being at this level where minus margins are set and causes screen locking
      // Refresh the app when signing up via storefront on mobile
      window.location.reload();
    }
  };
  return (
    <SignupContext.Provider
      value={{
        step,
        setStep,
        signupDialogActive,
        setSignupDialogActive,
        showLoginTitle,
        setShowLoginTitle,
        endOnboarding,
        basketTotal,
        setBasketTotal,
        buyerSelectBusinessId,
        setBuyerSelectBusinessId,
        redirectToMarket,
        setRedirectToMarket,
        redirectToSellarCreditOnboarding,
        setRedirectToSellarCreditOnboarding,
        hasAcceptedTermsAndConditions,
        setHasAcceptedTermsAndConditions,
        company,
        setCompany,
        creditLimitQuoteValue,
        setCreditLimitQuoteValue,
        buyerSignUpBusinessId,
        setBuyerSignUpBusinessId,
      }}
    >
      {children}
    </SignupContext.Provider>
  );
}
